import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent{
  @Input() title: string;
  @Output() selectedOptionChange = new EventEmitter<any>();
  public option: any;
  constructor(private cdr: ChangeDetectorRef) { }

  onOptionChange() {
    this.selectedOptionChange.emit(this.option);
    this.cdr.detectChanges();
  }
}
